/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-quick-layout.vue?vue&type=template&id=55f46340&scoped=true&"
import script from "./add-quick-layout.vue?vue&type=script&lang=js&"
export * from "./add-quick-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f46340",
  null
  
)

export default component.exports